import { LabMDM } from "../masterdata/models/lab";
import { Machine } from "../masterdata/models/machine";
import { MachineGeneratedFile } from "./machine-generated-file";

export class LiquidLevelDetectionRequest {
    lab: LabMDM;
    hamiltonFile: MachineGeneratedFile;
    machine: Machine;

    constructor(lab: LabMDM, hamiltonFile: MachineGeneratedFile, machine: Machine) {
        this.lab = lab;
        this.hamiltonFile = hamiltonFile;
        this.machine = machine;
    }
}
